exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".src-scenes-UserService-index_card--3yPawsAt .ant-card-head{margin-top:20px}", "", {"version":3,"sources":["D:/image/foundation/frontend/src/scenes/UserService/D:/image/foundation/frontend/src/scenes/UserService/index.less","D:/image/foundation/frontend/src/scenes/UserService/index.less"],"names":[],"mappings":"AAAA,4DAEI,eAAA,CCAH","file":"index.less","sourcesContent":[".card{\n  :global(.ant-card-head ){\n    margin-top:20px;\n  }\n}\n",".card :global(.ant-card-head ) {\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"card": "src-scenes-UserService-index_card--3yPawsAt"
};